import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuthStore } from '@/lib/store';
import { toast } from 'sonner';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { setUser } = useAuthStore();

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash.replace(/^#/, '');
      const params = new URLSearchParams(hash);
      const sid = params.get('session_id');
      if (!sid) {
        toast.error('Sign-in failed (missing session)');
        navigate('/login', { replace: true });
        return;
      }
      try {
        const r = await api.post('/auth/session', null, { headers: { 'X-Session-ID': sid } });
        if (r.data?.user) setUser(r.data.user);
        // clear hash
        history.replaceState({}, '', '/');
        toast.success(`Welcome, ${r.data?.user?.name || ''}`);
        navigate('/', { replace: true });
      } catch (err) {
        toast.error('Sign-in failed');
        navigate('/login', { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-dvh flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-3">
        <div className="h-9 w-9 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
